import { __assign } from "tslib";
import * as React from 'react';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { renderAndMountComponent } from '@wix/answers-lib';
import { createUserAvatarLegacyDriver } from '../user-avatar/user-avatar.legacy-driver';
import { CallCenterAvatar } from './call-center-avatar';
export var createCallCenterAvatarDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.call-center-avatar', CallCenterAvatar.name);
    var userAvatar = createUserAvatarLegacyDriver(wrapper);
    return {
        getInitials: function () { return userAvatar.getInitials(); },
        isProfileImgVisible: function () { return userAvatar.isProfileImgVisible(); },
        isStatusVisible: function () { return baseDriver.isChildVisible('.status-indicator'); },
        getStatus: function () {
            return parseInt(baseDriver.find('.status-indicator').getDataAttr('status'), 10);
        }
    };
};
export var createCallCenterAvatar = function (props) {
    var element = renderAndMountComponent(React.createElement(CallCenterAvatar, __assign({}, props)));
    return createCallCenterAvatarDriver(element);
};
//# sourceMappingURL=call-center-avatar.driver.js.map